import React from 'react';
import AppContext from '../context/appContext'
import { useContext } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const Referrals = () => {
    const progress = 22;

    // const anotherLevel = ["L1","L2","L3","L4","L5"]

    const appContext = useContext(AppContext)

    const { authToken, createAccount, setAuthToken, getUser, userData } = appContext

    console.log(userData);

   

    const levels = userData.level == 1 ? ["⭐", 10, 25, 45, 55, 60] : userData.level == 2 ? ["⭐", "⭐", 15, 35, 45, 60] : userData.level == 3 ? ["⭐", "⭐", "⭐", 20, 30, 35] : userData.level == 4 ? ["⭐", "⭐", "⭐", "⭐", 10, 15] : userData.level == 5 ? ["⭐", "⭐", "⭐", "⭐", "⭐", 5] : ["⭐", "⭐", "⭐", "⭐", "⭐", "⭐"];

    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getUTCFullYear()).slice(-2);

        return `${day}/${month}/${year}`;
    }

    return (
        <div className="px-md-5">
            <h1 className="text-light py-3">Referrals Status</h1>

            <div className="position-relative w-100 mx-auto mt-4">
                {/* Progress Bar */}
                <div className="progress" style={{ height: "20px", backgroundColor: "#0b4885" }}>
                    <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${userData.level == 1 ? 0 : userData.level == 2 ? 20 : userData.level == 3 ? 40 : userData.level == 4 ? 60 : userData.level == 5 ? 80 : 100}%`, backgroundColor: "gold" }}
                        aria-valuenow={userData.level == 1 ? 0 : userData.level == 2 ? 20 : userData.level == 3 ? 40 : userData.level == 4 ? 60 : userData.level == 5 ? 80 : 100}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>

                {/* Level Markers with Labels */}
                <div className="position-absolute top-0 start-0 w-100 d-flex justify-content-between text-center" style={{ marginTop: "-12px" }}>
                    {levels.map((level, index) => (
                        <div key={index} className="d-flex flex-column align-items-center">
                            {/* Circle with Level Inside */}
                            <div
                                className="p-3 d-flex align-items-center justify-content-center fw-bold"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    backgroundColor: "#23153c",
                                    border: "2px solid white",
                                    borderRadius: "60%",
                                    fontSize: "20px",
                                    color: "white",
                                }}
                            >
                                {level}
                            </div>
                            {/* Level Text Below */}
                            <span className="h4 mt-3 text-white ">L{index + 1}</span>
                        </div>
                    ))}
                </div>
            </div>
            <h1 className="text-light pb-3 mt-5 pt-2">Referrals Statistics</h1>
            <div className="row">
                <div className="col-sm-6 col-lg-6 col-12 my-2">
                    <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                        {/* <img src="..." class="card-img-top" alt="..."/> */}
                        <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                            <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.referrals.length}`}</p>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <h2 class="card-title text-light">Total Referrals</h2>
                            <p class="card-text text-light">Total number of referred users by your referral link</p>

                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-6 col-12 my-2">
                    <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                        {/* <img src="..." class="card-img-top" alt="..."/> */}
                        <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                            <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.referralBonus}$`}</p>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <h2 class="card-title text-light">Referral Earnings</h2>
                            <p class="card-text text-light">Total earnings from referred users by your referral link</p>

                        </div>
                    </div>
                </div>
            </div>
            <h1 className="text-light py-4">Referrals Users</h1>
            <div className="row">
                {userData.referrals.map((e, i) => {
                    return <div className="col-sm-6 col-lg-3 col-6 my-2">
                        <div data-aos-duration="1000" class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className=' h3 text-light' style={{ fontWeight: "bold" }}>{e.name}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <div className="mt-auto">
                                    <Link to={`/user-dashboard/transfer/${e.walletAddress}`}>  <button className="btn btn-light mb-3">Send Amount</button></Link>
                                    <h6 class="card-title text-light">Registered: {formatDate(e.date)}                                  </h6>
                                    {/* <p class="card-text text-light">Fully audited smart contract with zero human intervention</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                })}

            </div>
        </div>
    );
};

export default Referrals;
